var map = {
	"./testimonial-efecte.png": 353,
	"./testimonial-fleetguru.png": 354,
	"./testimonial-kiks.png": 355,
	"./testimonial-legal-jobs.png": 356,
	"./testimonial-lvs-brokers.png": 357,
	"./testimonial-medixine.png": 358,
	"./testimonial-oulan.png": 359,
	"./testimonial-puhujatori.png": 360,
	"./testimonial-renta.png": 361,
	"./testimonial-robu.png": 362,
	"./testimonial-speys.png": 363,
	"./testimonial-src-factory.png": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;